import { render, staticRenderFns } from "./HomePath.vue?vue&type=template&id=4223a79a"
import script from "./HomePath.vue?vue&type=script&lang=js"
export * from "./HomePath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports